import { Transform } from "class-transformer";
import { Length } from "../../../core/Length/Length";
import type { EShapeCabinetType } from "../../../core/ShapeTypes/EShapeCabinetType";
import { DrawShape } from "../DrawShape";
import { LengthParser } from "../../../core/Length/LengthParser";


export enum EShapeOrientation {
    L = 0,
    R = 1,
    S = 2,
    SL = 3,
    SR = 4,
    AL = 5,
    AR = 6
}

export class DrawCabinetShape extends DrawShape<EShapeCabinetType> {

    @Transform(params => LengthParser.parse(params.value))
    Width!: Length;
    @Transform(params => LengthParser.parse(params.value))
    Depth!: Length;
    @Transform(params => LengthParser.parse(params.value))
    Height!: Length;
    
    Orientation!: EShapeOrientation;

    get Shape(): EShapeCabinetType {
        return this.TypeName as unknown as EShapeCabinetType;
    }
}

